import { AppShell } from './AppShell';
import { AccountPage } from '../features/account/AccountPage';
import { AdminPage } from '../features/admin/AdminPage';
import { AgentPage } from '../features/agent/AgentPage';
import { CalendarPage } from '../features/calendar/CalendarPage';
import { HomePage } from '../features/home/HomePage';
import { LoginPage } from '../features/auth/LoginPage';
import { WhaleuPage } from '../features/whaleu/WhaleuPage';
import { FocusPage } from '../features/focus/FocusPage';

function normalize(pathname: string) {
  if (pathname.length > 1) return pathname.replace(/\/+$/, '');
  return pathname;
}

export function App() {
  const route = normalize(window.location.pathname);
  const focusRoute = route === '/focus' || (route === '/' && new URLSearchParams(window.location.search).get('view') === 'focus');
  if (route === '/login') return <LoginPage />;
  let page = focusRoute ? <FocusPage /> : <HomePage />;
  if (!focusRoute && route === '/account') page = <AccountPage />;
  else if (route === '/admin') page = <AdminPage />;
  else if (route === '/agent') page = <AgentPage />;
  else if (route === '/calendar') page = <CalendarPage />;
  else if (route === '/focus') page = <FocusPage />;
  else if (route === '/whaleu') page = <WhaleuPage />;
  else if (!focusRoute && route !== '/') page = <div className="content-column not-found"><p>CAIGEN · 404</p><h1>这一页尚未扎根</h1><a href="/">返回首页</a></div>;
  return <AppShell route={focusRoute ? '/focus' : route}>{page}</AppShell>;
}
